import get from 'lodash/get';
import { observer } from 'mobx-react';
import { FormEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Radio from 'components/elements/radio';

interface Props<T>
  extends Omit<Partial<HTMLSelectElement>, 'defaultValue' | 'value'> {
  name: string;
  data: T[];
  valueKey: keyof T;
  titleKey: keyof T;
  onChange?: (_value: string | number) => void;
  defaultValue?: number;
}

function OneSelected<T>({
  data,
  titleKey,
  valueKey,
  name,
  ...props
}: Props<T>) {
  const methods = useFormContext();

  const onChangeHandler = (e: FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    methods.setValue(name, value, {
      shouldTouch: true,
      shouldValidate: true,
    });
    if (props.onChange) props.onChange(value);
  };

  return (
    <Controller
      control={methods.control}
      defaultValue={props.defaultValue}
      name={name}
      render={({ field: { name: fieldName, value: _value } }) => (
        <>
          {data.map((item) => (
            <Radio
              name={fieldName}
              key={get(item, valueKey)}
              value={get(item, valueKey)}
              defaultChecked={_value === get(item, valueKey)}
              onChange={(e) => onChangeHandler(e)}
            >
              {get(item, titleKey)}
            </Radio>
          ))}
        </>
      )}
    />
  );
}

export default observer(OneSelected);
